"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { TDHHistory } from "@/entities/ITDH";
import UserPageStatsActivityTDHHistoryChart from "./UserPageStatsActivityTDHHistoryChart";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
interface ChartData {
  readonly label: string;
  readonly data: number[];
  readonly backgroundColor: string;
  readonly borderColor: string;
}
export interface ChartProps {
  readonly title: string;
  readonly labels: Date[];
  readonly datasets: ChartData[];
}
interface ChartConfigDataset {
  readonly label: string;
  readonly field: keyof TDHHistory;
  readonly color: string;
}
interface ChartConfig {
  readonly title: string;
  readonly datasets: ChartConfigDataset[];
}
const CHART_CONFIGS: ChartConfig[] = [{
  title: "Total TDH",
  datasets: [{
    label: "Total Boosted TDH",
    field: "boosted_tdh",
    color: "#00DC21"
  }]
}, {
  title: "Net TDH Daily Change",
  datasets: [{
    label: "Net Boosted TDH",
    field: "net_boosted_tdh",
    color: "#00DC21"
  }]
}, {
  title: "Created TDH Daily Change",
  datasets: [{
    label: "Created Boosted TDH",
    field: "created_boosted_tdh",
    color: "#00DC21"
  }]
}, {
  title: "Destroyed TDH Daily Change",
  datasets: [{
    label: "Destroyed Boosted TDH",
    field: "destroyed_boosted_tdh",
    color: "#00DC21"
  }]
}];
export default function UserPageStatsActivityTDHHistoryCharts(t0) {
  const $ = _c(9);
  const {
    tdhHistory
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [dataSets, setDataSets] = useState(t1);
  const isNumber = _temp;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const getData = t3 => {
      const {
        tdh,
        labels,
        field
      } = t3;
      return labels.map(l => {
        const tdhItem = tdh.find(t => t.date === l);
        if (!tdhItem) {
          return 0;
        }
        const value = tdhItem[field];
        return tdhItem && isNumber(value) ? value : 0;
      });
    };
    t2 = t4 => {
      const {
        tdh: tdh_0,
        labels: labels_0
      } = t4;
      return CHART_CONFIGS.map(config => ({
        title: config.title,
        labels: labels_0,
        datasets: config.datasets.map(d => ({
          label: d.label,
          data: getData({
            tdh: tdh_0,
            labels: labels_0,
            field: d.field
          }),
          backgroundColor: d.color,
          borderColor: d.color
        }))
      })).filter(_temp4);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getDataSets = t2;
  let t3;
  let t4;
  if ($[2] !== tdhHistory) {
    t3 = () => {
      if (!tdhHistory.length) {
        setDataSets([]);
        return;
      }
      const tdhHistoryReversed = tdhHistory.toReversed();
      const tdhLabels = tdhHistoryReversed.map(_temp5);
      setDataSets(getDataSets({
        tdh: tdhHistoryReversed,
        labels: tdhLabels
      }));
    };
    t4 = [tdhHistory];
    $[2] = tdhHistory;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== dataSets) {
    t5 = dataSets.map(_temp6);
    $[5] = dataSets;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="tw-mt-2 sm:tw-mt-4 tw-flex tw-flex-col tw-gap-y-6 md:tw-gap-y-8">{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp6(dataSet) {
  return <UserPageStatsActivityTDHHistoryChart key={getRandomObjectId()} data={dataSet} />;
}
function _temp5(t_0) {
  return t_0.date;
}
function _temp4(c) {
  return c.datasets.some(_temp3);
}
function _temp3(d_0) {
  return d_0.data.some(_temp2);
}
function _temp2(n_0) {
  return n_0 > 0;
}
function _temp(n) {
  return typeof n === "number";
}